export default "__VITE_ASSET__7c4b563d__"